import { ExitActionDTO } from "./exit-action.dto";
import { ExitAction } from "../exit-action.entity";
import { Injectable } from "@nestjs/common";

@Injectable()
export class ExitActionAdapter{

    public convertDtoToEntity(dto: ExitActionDTO, isUpdate: boolean = false): ExitAction{
        console.log(isUpdate+'////')
        console.log(dto+'>>>>>>>')
        const entity = new ExitAction();
        entity.employeeId = dto.employeeId;
        entity.exitDate = dto.exitDate;
        entity.exitReason = dto.exitReason;
        entity.remarks = dto.remarks;
        entity.approvedBy =dto.approvedBy;
        entity.isActive = dto.isActive == undefined ? true : dto.isActive;
        if(isUpdate){
            entity.exitActionId = dto.exitActionId;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: ExitAction): ExitActionDTO{
        const Dto = new ExitActionDTO();
        Dto.exitActionId = entity.exitActionId;
        Dto.employeeId = entity.employeeId;
        Dto.exitDate = entity.exitDate;
        Dto.exitReason = entity.exitReason;
        Dto.remarks = entity.remarks;
        Dto.approvedBy=entity.approvedBy;
        Dto.isActive = entity.isActive;
        Dto.createdAt = entity.createdAt;
        Dto.updatedAt = entity.updatedAt;
        Dto.createdUser = entity.createdUser;
        Dto.updatedUser = entity.updatedUser;
        Dto.versionFlag = entity.versionFlag;
        return Dto;
    }
}